import React, { useEffect, useState } from 'react';
import './App.css'; // 追加


const motivationalQuotes = [
  "今日も一日がんばろう！",
  "あなたならできる！",
  "小さな一歩が大きな成果に繋がる！",
  "諦めずに続ければ、きっと夢が叶う！",
  "あなたの努力は必ず報われる！",
  "ポジティブに進もう！",
  "失敗は成功のもと！",
  "自分を信じて進もう！",
  "心を込めて、今に集中！",
  "目標に向かってまっすぐ進もう！"
];

const App = () => {
  const [quote, setQuote] = useState("");

  useEffect(() => {
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }

    const interval = setInterval(() => {
      const randomQuote = motivationalQuotes[Math.floor(Math.random() * motivationalQuotes.length)];
      setQuote(randomQuote);

      if (Notification.permission === "granted") {
        new Notification("元気の出る言葉", {
          body: randomQuote,
        });
      }
    }, 10000); // 10秒ごとに表示

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>元気の出る言葉アプリ</h1>
      <p>{quote}</p>
      <p>このアプリは10秒ごとに元気の出る言葉を表示します。</p>
    </div>
  );
};

export default App;
